export default function R_Functions() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Functions Component</h1>
      <p>This is the R_Functions tutorial section.</p>
    </div>
  );
}
